import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'login-button',
  templateUrl: './login-button.component.html'
})
export class LoginButtonComponent implements OnInit {
  env = environment;

  constructor() { }

  ngOnInit() {
  }

}
